<script setup>
  import { ref, computed, watch, onMounted, watchEffect } from 'vue';
  import { useUserStore } from '@/stores/UserStore';
  import BaseModal from './base/BaseModal.vue';
  
  const emits = defineEmits(['close']);

  const props = defineProps({
    spotId: {
      type: [Number, Array],
      required: false
    },
    profileId: {
      type: Number,
      required: false
    },
    show: {
      type: Boolean,
      default: false
    },
  });

  const userStore = useUserStore();

  const spotIdArray = ref([]);
  const showModal = ref(false);

  const spotName = computed(() => {
    if (spotIdArray.value.length === 0) return 'N/A';

    const spotNames = spotIdArray.value.map(spotId => {
      const spot = userStore.getFavoriteSpotById(spotId);

      if (!spot) return 'N/A';
      
      return `<li><strong>${userStore.getFavoriteSpotById(spotId).name}</strong></li>`;
    }).join('');

    return `<ul>${spotNames}</ul>`;
  });

  const deleteText = computed(() => {
    if (spotIdArray.value.length === 0) return 'There are no spots selected for deletion.';

    const deleteCountText = spotIdArray.value.length === 1 ? 'this spot' : `these ${spotIdArray.value.length} spots`;

    return `Are you sure you want to delete ${deleteCountText}:${spotName.value}`;
  })

  function closeModal() {
    showModal.value = false;

    emits('close');
  }

  async function handleDeleteSpot() {
    const deletedSpotName = spotName.value;

    await userStore.deleteSpotsFromProfile(spotIdArray.value);
    await userStore.getProfiles(true);
    await userStore.getSpotDetailSetByProfile();

    const toastMessage = spotIdArray.value.length === 1
      ? `Deleted spot ${deletedSpotName}`
      : `Deleted ${spotIdArray.value.length} spots.`

    if (jwc) {
      jwc.toaster.toast({
        type: 'success',
        content: toastMessage,
      })
    }     

    spotIdArray.value = [];

    closeModal();
  }

  onMounted(() => {
    watchEffect(() => showModal.value = props.show);
  });

  watch(() => props.spotId, () => {
    spotIdArray.value = Array.isArray(props.spotId) ? props.spotId : [props.spotId];
  }, { immediate: true });

</script>

<template>
  <BaseModal
    v-model="showModal"
    :allowOutsideClick="false"
  >
    <header class="jwx-modal__header">
      <h2 class="jwx-modal__title">Delete Favorite Spot?</h2>
    </header>
    <div class="jwx-modal__body">
      <div class="jwx-modal__section">
        <p class="jwx-modal__text" v-html="deleteText"></p>
      </div>
    </div>
    <div class="jwx-modal__footer">
      <div class="jwx-modal__actions">
        <button
          type="button"
          @click.prevent="closeModal"
          class="jwx-button"
        >
          Cancel
        </button>
        <button 
          type="button" 
          @click.prevent="handleDeleteSpot"
          class="jwx-button jwx-button--danger"
        >
          Delete
        </button>
      </div>
    </div>
  </BaseModal>
</template>